// TODO v6: rename to gridEditingStateSelector
export const gridEditRowsStateSelector = state => state.editRows;


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/features/editRows/gridEditRowsSelector.js
// module id = 150
// module chunks = 25